/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Constants from '../Config/Config';
import {Loader} from '../Helpers/Helpers';

const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/backing.json';

// Same formula as Glass: unitPrice * (frameFullDimension + (top*4 + middle*4 + bottom*4))
function calcBackingTotal(backing, frameFullDimension, selectedMatSize, selectedTopMatValueInCM, selectedMiddleMatValueInCM, selectedBottomMatValueInCM) {
  const unitPrice = parseFloat(backing.cost != null ? backing.cost : backing.price) || 0;
  var topMatWidth = 0, middleMatWidth = 0, bottomMatWidth = 0;
  if (parseFloat(selectedMatSize) !== 0) topMatWidth = parseFloat(selectedTopMatValueInCM) || 0;
  if (parseFloat(selectedMatSize) === 2 || parseFloat(selectedMatSize) === 3) middleMatWidth = parseFloat(selectedMiddleMatValueInCM) || 0;
  if (parseFloat(selectedMatSize) === 3) bottomMatWidth = parseFloat(selectedBottomMatValueInCM) || 0;
  const frameNum = parseFloat(frameFullDimension) || 0;
  const matDimension = (topMatWidth * 4) + (middleMatWidth * 4) + (bottomMatWidth * 4);
  const dimension = frameNum + matDimension;
  return (unitPrice * dimension).toFixed(2);
}

class Backing extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
      error: null,
      backingsList: []  // keep local copy so content shows immediately after fetch
    }
    this.selectBacking = this.selectBacking.bind(this);
  }

  selectBacking (e) {
    this.dispatchSelectBacking(parseInt(e.currentTarget.value, 10));
  }

  fetchBacking = () => {
    var self = this;
    fetch(URL)
    .then(response => {
      if (!response.ok) {
        throw Error('Network request failed.')
      }
      return response;
    })
    .then(data => data.json())
    .then(data => {
      const backings = data.BACKING || [];
      if (self.props.selectedBacking === null && backings.length > 0) {
        const first = backings[0];
        const backingTotal = calcBackingTotal(first, self.props.frameFullDimension, self.props.selectedMatSize, self.props.selectedTopMatValueInCM, self.props.selectedMiddleMatValueInCM, self.props.selectedBottomMatValueInCM);
        self.props.dispatch({
          type: 'SET_STATE',
          state: {
            backings: backings,
            selectedBacking: 0,
            selectedBackingName: first.type,
            backingTotal: backingTotal
          }
        });
      } else {
        self.dispatchBackingData(backings);
      }
      self.setState({ isLoaded: true, backingsList: backings });
    }, (ex) => {
      self.setState({ error: ex.message });
    })
  }

  dispatchBackingData(BackingData) {
    this.props.dispatch({
      type: 'SET_STATE',
      state: {
        backings: BackingData
      }
    })
  }

  dispatchSelectBacking(index) {
    const backings = (this.state.backingsList && this.state.backingsList.length > 0) ? this.state.backingsList : (this.props.backings || []);
    const backing = backings[index];
    if (backing) {
      const backingTotal = calcBackingTotal(backing, this.props.frameFullDimension, this.props.selectedMatSize, this.props.selectedTopMatValueInCM, this.props.selectedMiddleMatValueInCM, this.props.selectedBottomMatValueInCM);
      this.props.dispatch({
        type: 'SET_STATE',
        state: {
          selectedBacking: index,
          selectedBackingName: backing.type,
          backingTotal: backingTotal
        }
      })
    } else {
      this.props.dispatch({
        type: 'SET_STATE',
        state: {
          selectedBacking: index,
          selectedBackingName: null,
          backingTotal: '0.00'
        }
      })
    }
  }

  componentDidMount() {
    this.fetchBacking();
  }

  render() {
    const { isLoaded, error, backingsList } = this.state;
    const backings = (backingsList && backingsList.length > 0) ? backingsList : (this.props.backings || []);
    const selectedBacking = this.props.selectedBacking;
    if (error) {
      return <div className="alert alert-danger">{error}</div>;
    } else if (!isLoaded) {
      return <div className="loadingSec"><Loader/></div>;
    } else if (!backings.length) {
      return <div className="loadingSec"><Loader/></div>;
    }
    const selectedBackingData = selectedBacking != null && backings[selectedBacking]
      ? backings[selectedBacking]
      : null;
    const selectedCostDescription = selectedBackingData && (selectedBackingData.cost_description != null ? selectedBackingData.cost_description : (selectedBackingData.get ? selectedBackingData.get('cost_description') : ''));

    return (
      <div className="row">
        <div className="col-sm-12 backing-tab-content">
          <div className="backing-options-list">
            {backings.map((backing, index) => {
              const type = backing && (backing.type != null ? backing.type : (backing.get ? backing.get('type') : ''));
              const description = backing && (backing.description != null ? backing.description : (backing.get ? backing.get('description') : ''));
              const isSelected = selectedBacking === index;
              return (
                <div
                  key={index}
                  role="button"
                  tabIndex={0}
                  className={`backing-option-row ${isSelected ? 'selected' : ''}`}
                  onClick={() => this.dispatchSelectBacking(index)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.dispatchSelectBacking(index);
                    }
                  }}
                >
                  <div className="backing-row1">
                    <div className="backing-row1-left">
                      <label className="checkcontainer backing-radio-label">
                        <input
                          type="radio"
                          name="backing"
                          value={index}
                          onChange={this.selectBacking}
                          checked={isSelected}
                        />
                        <span className="radiobtn"></span>
                      </label>
                      <div className="backing-title">{type}</div>
                    </div>
                  </div>
                  <div className="backing-row2">
                    <div className="backing-row2-spacer" aria-hidden="true" />
                    <div className="backing-description">{description}</div>
                  </div>
                </div>
              );
            })}
          </div>
          <div className="backing-price-block">
            <div className="price-tab">
              {Constants.Currency + (this.props.backingTotal != null ? this.props.backingTotal : '0.00')}
            </div>
            <div className="backing-cost-description">{selectedCostDescription || '\u00A0'}</div>
          </div>
        </div>
      </div>
    );
  }
}
export default Backing;
